import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../firebase/config';

// Factory that returns thin CRUD helpers for a per-tournament subcollection
// at `tournaments/{tournamentId}/{name}`. Every management component uses these
// instead of touching `firebase/firestore` directly, keeping data access out of
// the UI (see CLAUDE.md). Returned docs are always `{ id, ...data }`.
export const makeSubcollection = (name) => {
  const col = (tid) => collection(db, 'tournaments', tid, name);
  const ref = (tid, id) => doc(db, 'tournaments', tid, name, id);

  return {
    col,
    ref,
    // List, optionally constrained by orderBy/where clauses.
    list: async (tid, ...constraints) => {
      if (!tid) return [];
      const snap = await getDocs(constraints.length ? query(col(tid), ...constraints) : col(tid));
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },
    get: async (tid, id) => {
      if (!tid || !id) return null;
      const snap = await getDoc(ref(tid, id));
      return snap.exists() ? { id: snap.id, ...snap.data() } : null;
    },
    // Create with an auto id. Stamps createdAt/updatedAt.
    create: (tid, data) =>
      addDoc(col(tid), { ...data, createdAt: Timestamp.now(), updatedAt: Timestamp.now() }),
    // Partial update by id. Stamps updatedAt.
    update: (tid, id, data) => updateDoc(ref(tid, id), { ...data, updatedAt: Timestamp.now() }),
    // Write a full doc at a deterministic id (idempotent upsert). Stamps updatedAt.
    set: (tid, id, data, options) =>
      setDoc(ref(tid, id), { ...data, updatedAt: Timestamp.now() }, options || {}),
    remove: (tid, id) => deleteDoc(ref(tid, id)),
  };
};
